import React from 'react';
import { useDispatch } from 'react-redux';
import CheckoutSection from './utils/Checkout.Section';
import CheckoutSectionContent from './utils/Checkout.SectionContent';
import { translate } from '../../Services/translation';
import useDebouncedOnChange from '../../Hooks/useDebouncedOnChange';
import { setOrderNote as setOrderNoteAction } from '../../Actions/Checkout.action';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import TextArea from '../Inputs/TextArea';
import Input from '../Inputs/Input';
import EditorString from '../EditorString/EditorString';

const OrderReference = () => {
  const dispatch = useDispatch();
  const checkout = useTypedSelector((state) => state.checkout);
  const { customerServiceMessage } = checkout.payload;
  const [comments, setOrderNote] = useDebouncedOnChange('', () => dispatch(setOrderNoteAction(comments)));

  return (
    <CheckoutSection title={translate('checkout.orderreference.title')}>
      <CheckoutSectionContent>
        {customerServiceMessage && (
          <EditorString value={customerServiceMessage.value}
          />
        )}
        <Input
          inputSize="xlarge"
          label={translate('checkout.orderreference.title')}
          id="additional-info__input"
          placeholder={translate('checkout.orderreference.input')}
          onChange={(e) => setOrderNote(e.target.value)}
        />
      </CheckoutSectionContent>
    </CheckoutSection>
  );
};

export default OrderReference;
